export default "__VITE_ASSET__a4e6fe81__"